import { Container } from 'react-bootstrap';
import { motion } from 'framer-motion';
import parse from 'html-react-parser';
import { initialGoDown, transition, whileInView } from '../../../helpers/animations';
import { useTranslation } from 'react-i18next';
import { getHighlightCardIndexes, useHomeTranslationsQuery } from '../../../services/HomePageServices';
import { sanitizeCmsHtml } from '../../../helpers/sanitizeCmsHtml';

interface HighlightsCardProps {
  card: number;
}

function HighlightsSection() {
  const { t } = useTranslation('highlight');
  const homeQuery = useHomeTranslationsQuery();
  const highlightTrans = homeQuery.data ? getHighlightCardIndexes(homeQuery.data) : undefined;
  const isLoading = homeQuery.isLoading;

  if (isLoading || !highlightTrans) {
    return null;
  }

  return (
    <section id="highlights" className="highlights-section">
      <Container className='highlights-section__container'>
        <motion.p
          initial={initialGoDown}
          whileInView={whileInView}
          viewport={{
            once: true,
            amount: 0.2
          }}
          transition={transition}
          className="highlights-section__name"
        >{t('highlight_section_name')}</motion.p>
      </Container>

      <Container>
        <motion.div
          initial={initialGoDown}
          whileInView={whileInView}
          viewport={{
            once: true,
            amount: 0.2
          }}
          transition={transition}
          className="highlights-section__title"
        >{t('highlight_title')}
        </motion.div>
      </Container>

      <Container>
        <motion.p
          initial={initialGoDown}
          whileInView={whileInView}
          viewport={{
            once: true,
            amount: 0.2
          }}
          transition={transition}
          className="highlights-section__description"
        >{parse(sanitizeCmsHtml(t('highlight_description')))}</motion.p>
      </Container>
      <Container className='highlights-section__cards-container'>
        <motion.div
          initial={initialGoDown}
          whileInView={whileInView}
          viewport={{
            once: true,
            amount: 0.2
          }}
          transition={transition}
          className="highlights-section__cards"
        >
          {
            highlightTrans.map((value, index) => {
              return(
                <HighlightsCard key={index} card={index}/>
              );
            })
          }
        </motion.div>
      </Container>
    </section>
  );
}

export default HighlightsSection;

function HighlightsCard({ card }: HighlightsCardProps) {
  const { t } = useTranslation('highlight');
  return (
    <div className="highlights-card">
      <img
        className="highlights-card__img"
        src={t(`highlight_card_image_link_${card}`)}
        alt=""
        loading="lazy"
        decoding="async"
      />
      <div className="highlights-card__textbox">
        <h4 className="highlights-card__textbox__title">{t(`highlight_card_title_${card}`)}</h4>
        <p className="highlights-card__textbox__text">{parse(sanitizeCmsHtml(t(`highlight_card_description_${card}`)))}</p>
      </div>
    </div>
  );
}
